import { Spinner } from "@phosphor-icons/react";
import { useNavigate, useParams } from "react-router-dom";

import { EditBundleForm } from "@/components/Materials/Forms/EditBundleForm";
import { useBundles } from "@/hooks";
import { ROUTES } from "@/router/routes";
import { Breadcrumb } from "@/ui";

export const EditBundle = () => {
  const { bundleId } = useParams();
  const navigate = useNavigate();
  const { useBundle } = useBundles();
  const { data: bundleData, isLoading } = useBundle(bundleId);

  const bundle = bundleData;

  const handleClose = () => {
    navigate(ROUTES.coursesAndMaterials);
  };

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner className="animate-spin text-4xl text-primary-600" />
      </div>
    );
  }

  if (!bundle) {
    return <div>Bundle not found</div>;
  }

  return (
    <div className="flex flex-col gap-y-6 p-8">
      <Breadcrumb
        items={[
          {
            label: "Courses & Materials",
            href: ROUTES.coursesAndMaterials,
          },
          {
            label: `Edit ${bundle.name}`,
            href: `/bundles/${bundleId}/edit`,
          },
        ]}
        current={`Edit ${bundle.name}`}
        onItemClick={(item) => {
          if (item.href) {
            navigate(item.href);
          }
        }}
      />

      <div className="mx-auto w-full max-w-5xl rounded-xl border border-neutral-200 bg-white p-8 shadow-sm">
        <h1 className="mb-2 text-3xl font-bold text-neutral-900">
          Edit {bundle.name}
        </h1>
        <p className="mb-8 border-b pb-4 text-neutral-500">
          Manage bundle details and content.
        </p>
        <EditBundleForm bundle={bundle} onClose={handleClose} />
      </div>
    </div>
  );
};
